import React from 'react'
import styled from 'styled-components'

const Button = styled.a`
  line-height: 2;
  height: 30px;
  text-decoration: none;
  display:inline-flex;
  color: #FFFFFF;
  background-color: #FF813F;
  border-radius: 30px;
  border: 1px solid transparent;
  padding: 0.7rem 2rem 0.7rem 2rem;
  font-size: 2rem;
  letter-spacing: 0.6px;
  box-shadow: 0px 1px 2px rgba(190, 190, 190, 0.5);
  transition: 0.3s all linear;
  font-family: cursive;
  &:hover, &:active, &:focus {
    text-decoration: none;
    box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5);
    opacity: 0.85;
    color: #FFFFFF;
  }
`;

const Image = styled.img`
  height: 25px;
  width: 30px;
  margin-bottom: 1px;
  box-shadow: none;
  border: none;
  vertical-align: middle;
  margin-top: 3px;
`;

const Text = styled.span`
  margin-top: -7px;
  margin-left: 5px;
  font-size: 22px;
  vertical-align: middle;
`;

const BuyMeCoffeeButton = () => {
  return (
    <Button target="_blank" href="https://www.buymeacoffee.com/KZFHhS7">
      <Image src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee" />
      <Text>Buy me a coffee</Text>
    </Button>
  );
}

export default BuyMeCoffeeButton